import SectionReveal from "@/components/SectionReveal";

/**
 * Reusable premium section heading.
 * Usage:
 *   <SectionHeading
 *     eyebrow="Recent updates"
 *     heading={["What's been growing,", "everywhere we work."]}
 *     italicIndex={1}
 *     description="Optional body copy below the heading."
 *     align="left"
 *   />
 */
export default function SectionHeading({
    eyebrow,
    heading,
    italicIndex,
    description,
    align = "left",
    maxWidth = "max-w-3xl",
    light = false,
    className = "",
}) {
    const isArray = Array.isArray(heading);
    const lines = isArray ? heading : [heading];
    const alignment =
        align === "center"
            ? "text-center mx-auto items-center"
            : "text-left items-start";

    return (
        <div className={`flex flex-col ${alignment} ${className}`}>
            {eyebrow && (
                <SectionReveal>
                    <span
                        className={`eyebrow ${
                            light ? "text-white/70" : ""
                        }`}
                    >
                        {eyebrow}
                    </span>
                </SectionReveal>
            )}
            <SectionReveal delay={0.06}>
                <h2
                    className={`font-display tracking-tight leading-[0.98] mt-6 text-4xl md:text-5xl lg:text-6xl ${maxWidth} ${
                        light ? "text-white" : "text-seedh-blue"
                    }`}
                >
                    {lines.map((line, i) => (
                        <span key={i} className="block">
                            {i === italicIndex ? (
                                <span
                                    className={`font-display-italic ${
                                        light
                                            ? "text-seedh-surface-green"
                                            : "text-seedh-green"
                                    }`}
                                >
                                    {line}
                                </span>
                            ) : (
                                line
                            )}
                        </span>
                    ))}
                </h2>
            </SectionReveal>
            {description && (
                <SectionReveal delay={0.12}>
                    <p
                        className={`mt-6 text-base md:text-lg leading-relaxed ${maxWidth} ${
                            light ? "text-white/80" : "text-seedh-muted"
                        }`}
                    >
                        {description}
                    </p>
                </SectionReveal>
            )}
        </div>
    );
}
